import { serializerNotRegistered1ovw7obgbxuzq as serializerNotRegistered } from './internal/Platform.common.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { CONTEXTUAL_getInstance1845118lbzky0 as CONTEXTUAL_getInstance } from './descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from './descriptors/SerialDescriptors.mjs';
import { withContext3ge61vpog00ae as withContext } from './descriptors/ContextAware.mjs';
import { get_EMPTY_SERIALIZER_ARRAY2gyuhuf2kalz as get_EMPTY_SERIALIZER_ARRAY } from './internal/PluginHelperInterfaces.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from './KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function serializer($this, serializersModule) {
  var tmp0_elvis_lhs = serializersModule.yy($this.uy_1, $this.wy_1);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? $this.vy_1 : tmp0_elvis_lhs;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    serializerNotRegistered($this.uy_1);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
var ContextualSerializerClass;
function ContextualSerializer() {
  if (ContextualSerializerClass === VOID) {
    class $ {
      static zy(serializableClass, fallbackSerializer, typeArgumentsSerializers) {
        var $this = createThis(this);
        $this.uy_1 = serializableClass;
        $this.vy_1 = fallbackSerializer;
        $this.wy_1 = asList(typeArgumentsSerializers);
        var tmp = $this;
        var tmp_0 = CONTEXTUAL_getInstance();
        tmp.xy_1 = withContext(buildSerialDescriptor('kotlinx.serialization.ContextualSerializer', tmp_0, [], ($this$buildSerialDescriptor) => {
          var tmp = $this$buildSerialDescriptor;
          var tmp0_safe_receiver = $this.vy_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.az();
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bz();
          tmp.ez_1 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
          return Unit_instance;
        }), $this.uy_1);
        return $this;
      }
      static kz(serializableClass) {
        return this.zy(serializableClass, null, get_EMPTY_SERIALIZER_ARRAY());
      }
      az() {
        return this.xy_1;
      }
      lz(encoder, value) {
        encoder.nz(serializer(this, encoder.mz()), value);
      }
      oz(encoder, value) {
        return this.lz(encoder, !(value == null) ? value : THROW_CCE());
      }
      pz(decoder) {
        return decoder.qz(serializer(this, decoder.mz()));
      }
    }
    initMetadataForClass($, 'ContextualSerializer', VOID, VOID, [KSerializer()]);
    ContextualSerializerClass = $;
  }
  return ContextualSerializerClass;
}
//region block: exports
export {
  ContextualSerializer as ContextualSerializer1uidivg94sh5v,
};
//endregion

//# sourceMappingURL=ContextualSerializer.mjs.map
